import { Stack } from '@mui/material'
import InvoiceEditTable from '../invoice-details/invoice-edit-table/invoice-edit-table'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import InvoiceEditViewFrom from './invoice-edit-view-from/invoice-edit-view-from'
import InvoiceEditViewTo from './invoice-edit-view-to/invoice-edit-view-to'
import ActionButtons from '../../../components/action-buttons/action-buttons.component'
import {
  useEditInvoiceByIdMutation,
  useGetInvoiceByIdQuery,
} from '../../../store/invoices/invoices.api'
import { useEffect, useState } from 'react'
import { InvoiceLineItem, InvoiceResponse } from 'store/invoices/invoices.types'

const InvoiceEditView = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const listBasePath = pathname.startsWith('/factoring') ? '/factoring' : '/invoice'
  const params = useParams()

  const { data: invoice, refetch } = useGetInvoiceByIdQuery({
    id: params?.invoiceId || '',
  })
  const [editInvoice, { isError }] = useEditInvoiceByIdMutation()

  const [lines, setLines] = useState<InvoiceLineItem[] | undefined>(
    invoice?.lineItems
  )

  const handleSave = async () => {
    try {
      if (!!lines) {
        await editInvoice({ ...invoice, lineItems: lines } as unknown as Omit<
          InvoiceResponse,
          'createdDate' | 'updatedDate' | 'events'
        >)
      }
      if (!isError) navigate(listBasePath)
    } catch (error) {
      console.log('Error editing invoice', error)
    }
  }

  useEffect(() => {
    setLines(invoice?.lineItems)
  }, [invoice?.lineItems])

  useEffect(() => {
    refetch()
  }, [refetch])

  return (
    <Stack sx={{ height: '100%' }}>
      <Stack p={2}>
        <InvoiceEditViewFrom {...invoice} />
        <InvoiceEditViewTo {...invoice} />
      </Stack>

      {!!invoice && (
        <div style={{ margin: '12px', height: '100vh' }}>
          <InvoiceEditTable
            invoice={invoice}
            lines={lines}
            setLines={setLines}
          />
        </div>
      )}

      <ActionButtons
        firstBtnProps={{
          title: 'Cancel',
          bgcolor: 'secondary.main',
          onClick: () => navigate(listBasePath),
        }}
        secondBtnProps={{
          title: 'Save',
          bgcolor: 'primary.main',
          onClick: handleSave,
        }}
      />
    </Stack>
  )
}

export default InvoiceEditView
